
import {TRACKER_TYPES} from 'consts/ttypes'
import CompanyType from './company-type.vue'

const TRACKER_TYPE_VALUES = TRACKER_TYPES.map(t => t.value)

export default {
  components: {CompanyType},
  props: {
    logo: {type: String, default: undefined},
    name: {type: String, default: ''},
    type: {type: String,
      required: false,
      default: undefined,       
      validator(value) {
        return value ==undefined || TRACKER_TYPE_VALUES.includes(value)
      }},
  },
  emits: ['close'],
}
